/* eslint-disable jsx-a11y/anchor-is-valid */
import {Fragment, useEffect} from 'react'
import {Outlet, Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../_metronic/helpers'

const AuthLayout = () => {
  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  return (
    <Fragment>
      <Outlet />
    </Fragment>
  )
}

export {AuthLayout}
